import BadgeComponent from './Badge';
import type { IBadgeComponentType } from './Badge.types';

const Badge = BadgeComponent as IBadgeComponentType;

export { Badge };
export * from './Badge.types';
